module.exports = __webpack_public_path__ + "static/media/sova.176ad20a.png";